import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 3 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

import crudsService from "services/cruds-service";
import { useParams } from "react-router-dom";
import i18n from "i18n";
import prepareNewArr from "helper/prepareNewArr";
import deepDiff from "helper/deep-diff";
import LangForm from "./langForm";
import MainInfo from "./MainInfo";
import getEmptyFields from "helper/getEmptyFields";
import MDAlert from "components/MDAlert";

function AddReport() {
  const { t } = i18n;

  const { id } = useParams();
  const [project, setProject] = useState({
    id: null,
    status: "draft",
    sequence: 0,
    year: null,
    translations: {},
  });
  const [info, setInfo] = useState({
    id: null,
    status: "draft",
    sequence: 0,
    year: null,
    translations: {},
  });
  const [linfo, setLInfo] = useState({
    translations: {},
  });

  const [notification, setNotification] = useState({
    value: false,
    color: "info",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const errorChk = {
    status: "draft",
    sequence: 0,
    year: null,
    translations: { title: "", summary: "", report: null },
  };

  const getProjects = async () => {
    const response = await crudsService.getAllData(
      `items/reports/${id}?fields=*,translations.*,translations.languages_code.name,translations.languages_code.code`
    );

    setProject((prevProject) => ({
      ...prevProject,
      translations: response.data.translations.reduce((acc, translation) => {
        acc[translation.languages_code.code] = { ...translation };
        return acc;
      }, {}),
      title: response.data.translations[0]?.title,
      id: response.data.id,
      sequence: response.data.sequence,
      year: response.data.year,
      status: response.data.status,
    }));
  };

  //if id change (when click edit from projects page) get the project data
  useEffect(() => {
    if (!id) return;
    getProjects();
  }, [id]);

  useEffect(() => {
    if (!project) return;

    setInfo({
      sequence: project?.sequence,
      year: project?.year,
      status: project?.status,
    });
  }, [project]);

  const changeHandler = (e, lang) => {
    if (lang) {
      setLInfo({
        translations: {
          ...linfo.translations,
          [lang]: {
            ...linfo.translations[lang],
            [e.target.name]: e.target.value,
            languages_code: lang,
          },
        },
      });
    } else {
      setInfo({
        ...info,
        [e.target.name]: e.target.value,
      });
    }
  };

  const autoSwitchChangeHandler = (name, v) => {
    setInfo({
      ...info,
      [name]: v,
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      // const { status, ...other } = info;
      // let obj = { ...getEmptyFields(other) };
      // Object.assign(obj, getEmptyFields(linfo.translations["ar-SA"], "ar-SA"));
      // Object.assign(
      //   obj,
      //   getEmptyFields(
      //     linfo.translations["en-US"]
      //       ? {
      //           ...linfo.translations["en-US"],
      //           report: linfo.translations["en-US"]?.report,
      //         }
      //       : {
      //           title: "",
      //           summary: "",
      //           report: null,
      //         },
      //     "en-US"
      //   )
      // );
      // Object.assign(
      //   obj,
      //   getEmptyFields(
      //     linfo.translations["tr-TR"]
      //       ? {
      //           ...linfo.translations["tr-TR"],
      //           report: linfo.translations["tr-TR"]?.report,
      //         }
      //       : {
      //           title: "",
      //           summary: "",
      //           report: null,
      //         },
      //     "tr-TR"
      //   )
      // );
      const { translations, ...other } = errorChk;

      let obj = {
        ...getEmptyFields(info, "", other),
        ...getEmptyFields(linfo.translations["ar-SA"], "ar-SA", translations),
        ...getEmptyFields(
          linfo.translations["en-US"]
            ? {
                ...linfo.translations["en-US"],
                report: linfo.translations["en-US"]?.report,
              }
            : {
                title: "",
                summary: "",
                report: null,
              },
          "en-US",
          translations
        ),
        ...getEmptyFields(
          linfo.translations["tr-TR"]
            ? {
                ...linfo.translations["tr-TR"],
                report: linfo.translations["tr-TR"]?.report,
              }
            : {
                title: "",
                summary: "",
                report: null,
              },
          "tr-TR",
          translations
        ),
      };
      const hasErrors = Object.values(obj).some((v) => v === true);
      console.log(obj, linfo.translations);

      if (hasErrors) {
        setErrors(obj);
        return; // stop
      }

      const trns = Object.values(linfo.translations);

      for (const key in trns) {
        if (!Object.hasOwn(trns, key)) continue;

        const item = trns[key];
        if (item.report && item.report instanceof File) {
          const formData = new FormData();
          formData.append("attachment", item.report);
          let img = await crudsService.uploadImage(formData);
          item.report = img.id;
        } else if (item.report === null) {
          delete item.report;
        }
      }

      if (id) {
        await crudsService.updateItem(`items/reports/${id}`, {
          sequence: info?.sequence,
          year: info?.year,
          status: info?.status,
          translations: trns,
        });
      } else {
        await crudsService.createItem(`items/reports`, {
          sequence: info?.sequence,
          year: info?.year,
          status: info?.status,
          translations: trns,
        });
      }
      setNotification({
        value: true,
        color: "success",
        text: "تم الحفظ بنجاح",
      });

      // console.log(diff);
    } catch (err) {
      console.error(err);
      setNotification({
        value: true,
        color: "error",
        text: "حدث خطأ ما، الرجاء المحاولة مرة أخرى",
      });
    }
  };

  return (
    <DashboardLayout>
      <MDBox my={3}>
        <MDBox mb={6}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MDTypography variant="h4" fontWeight="medium" color="info">
                {project?.title || "صفحة التقارير"}
              </MDTypography>
            </Grid>
            <Grid item xs={12} lg={6}>
              <MDBox display="flex" justifyContent="flex-end">
                <MDButton
                  variant="gradient"
                  color="info"
                  onClick={submitHandler}
                >
                  {t("save")}
                </MDButton>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        {notification.value && (
          <MDAlert color={notification.color} my="20px">
            <MDTypography variant="body2" color="white">
              {notification.text}
            </MDTypography>
          </MDAlert>
        )}
        <Grid container spacing={3}>
          <Grid item xs={12} lg={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <MainInfo
                  changeHandler={changeHandler}
                  autoSwitchChangeHandler={autoSwitchChangeHandler}
                  setInfo={setInfo}
                  info={info}
                  setErrors={setErrors}
                  errors={errors}
                  notification={notification}
                  setNotification={setNotification}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={9}>
            <LangForm
              project={project}
              changeHandler={changeHandler}
              setInfo={setLInfo}
              info={linfo}
              notification={notification}
              setNotification={setNotification}
              errors={errors}
              setErrors={setErrors}
            />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddReport;
